import { render, staticRenderFns } from "./mediabar.component.vue?vue&type=template&id=3905843e&scoped=true&"
import script from "./mediabar.component.js?vue&type=script&lang=js&"
export * from "./mediabar.component.js?vue&type=script&lang=js&"
import style0 from "./mediabar.component.scss?vue&type=style&index=0&id=3905843e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905843e",
  null
  
)

export default component.exports